/**
 * Checks if collections should be rendered based on specific conditions:
 * - Returns false if all collections have content with empty_set property set to true
 * - Returns true if at least one collection has content without empty_set: true
 * @param {Array} collections - Array of collection objects
 * @returns {boolean} - true if collections should be rendered, false otherwise
 */

export function shouldRenderCollections(collections) {
  if (!Array.isArray(collections) || collections.length === 0) {
    return false
  }

  const allCollectionsEmpty = collections.every((collection) => {
    if (!collection?.content || !Array.isArray(collection.content)) {
      return false
    }
    return collection.content.some((item) => item?.empty_set === true)
  })

  return !allCollectionsEmpty
}
